/**
 * @author Oguntuberu Nathan O. <nateoguns.work@gmail.com>
 */

import { TwitterService } from 'src/app/services/social/twitter.service';

class TwitterHandler {
    twitter_setting: any = {};
    twitter_account: any = {};
    listener_pattern: any;

    constructor(private twitter_service: TwitterService) {
        //
        this.twitter_service.fetch_user_data().subscribe((response: any) => {
            if (response.success) {
                this.twitter_account = { ...response.payload };
            }
        });

        this.twitter_service.fetch_stream_setting().subscribe((response: any) => {
            if (response.success) {
                this.set_twitter_settings(response.payload);
            }
        })

        /** OBSERVERS */
        this.twitter_service.user_data.subscribe(data => {
            if (Object.keys(data).length) {
                this.twitter_account = { ...data };
            }
        });

        this.twitter_service.listener_settings.subscribe(data => {
            if (Object.keys(data).length) {
                this.set_twitter_settings({ ...data });
            }
        });
    }

    buildListenerPattern(handles: Array<string>, hashtags: Array<string>) {
        let regex_params = [];

        if (handles && handles.length) {
            handles.forEach(handle => {
                if (!handle.length) return;
                regex_params.push(`@${handle.trim()}`);
            });
        }

        if (hashtags && hashtags.length) {
            hashtags.forEach(hashtag => {
                if (!hashtag.length) return;
                regex_params.push(`#${hashtag.trim()}`);
            });
        }

        return `(${regex_params.join('|')})`;
    }

    parseTweet(tweet) {
        if (!tweet.text) return;

        const processed_text = tweet.text.replace(this.listener_pattern, `<span class='text-primary'><b>$&</b></span>`);
        const date = new Date(tweet.created_at);
        const parsed_tweet = {
            ...tweet,
            date: `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`,
            is_handled: false,
            modal_id: `${tweet.tweet_id}twitter`,
            service: 'twitter',
            text: processed_text,
        }

        return parsed_tweet;
    }

    set_twitter_settings(data) {
        if (Object.keys(data).length) {
            const { handles, hashtags } = data;
            this.twitter_setting = { ...data };
            this.listener_pattern = new RegExp(this.buildListenerPattern(handles, hashtags), 'gi');
        }
    }
}

export default TwitterHandler;